import {post} from "../server/axios";
const baseUrl = window.webConfig.baseApiPath;

export const getDepList  = (json)=>{
    const url = `${baseUrl}/shwsgs/getDepList`;
    return post(url,json)
};

export const getCaseInfoList  = (json)=>{
    const url = `${baseUrl}/shwsgs/getCaseInfoList`;
    return post(url,json)
};
export const getCaseInfoDetail  = (id)=>{
    const url = `${baseUrl}/shwsgs/getCaseInfoDetail/${id}`;
    return post(url)
};
